import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { FrequencyAlertService } from 'src/app/services/frequency-alert.service';
import { AuthenticationService } from 'authentication';
import { ToastrService } from 'ngx-toastr';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-document-expiry-alert-settings',
  templateUrl: './document-expiry-alert-settings.component.html',
  styleUrls: ['./document-expiry-alert-settings.component.scss']
})
export class DocumentExpiryAlertSettingsComponent implements OnInit {

  docFrequencyList = [];
  isEditing = false;
  frequencyForm: FormGroup;
  isAdmin
  constructor(private toasterService: ToastrService, private referenceLibraryService: ReferenceLibraryService, private authenticationService: AuthenticationService, private fb: FormBuilder, private frequencyAlertService: FrequencyAlertService) { }

  ngOnInit(): void {
    this.initializaForm();
    this.getFrequencyListing();
    this.isAdmin = sessionStorage.getItem('ISADMIN');
  }

  ngAfterViewInit() {
    this.translet();
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }

  getFrequencyListing() {
    debugger;
    let userId = +sessionStorage.getItem('userId');
    this.frequencyAlertService.getDocFrequencyAlertListing(userId).subscribe(
      (res)=> {
        this.docFrequencyList = res;
        this.fillFormArray(this.docFrequencyList);
      }
    )
  }

  saveFrequencyListing(isSaveFor) {
    let userId = +sessionStorage.getItem('userId');
    let payload = this.getFormArray()?.value;
    if(this.checkForNegativeFrequencies(payload)) {
      this.toasterService.error('frequency days cannot be a negative number');
      return
    }
    if(!this.checkDuplicateFrequencies(payload)) {
      this.frequencyAlertService.saveFrequencyListing(payload, userId, isSaveFor).subscribe(
        (res: any)=> {
          this.toasterService.success(res.message, 'Success');
          this.isEditing = false;
          this.getFrequencyListing();
        }
      )
    }
  }

  checkForNegativeFrequencies(payload) {
    return payload.some(
      item => item.frequency1 < 0 || item.frequency2 < 0 || item.frequency3 < 0 || item.frequency4 < 0 || item.frequency5 < 0
    )
  }

  checkDuplicateFrequencies(payload) {
    let result;
    payload.forEach(doc => {
      const frequencyItem = [
          doc.frequency1,
          doc.frequency2,
          doc.frequency3,
          doc.frequency4,
          doc.frequency5,
          doc.documentType
      ];
      frequencyItem.forEach((value, index) => {
        if(value && frequencyItem.indexOf(value) !== index) {
          this.toasterService.error(`frequencies cannot be the same for documentType : ${frequencyItem[5]}`);
          result = true;
        }
      })
      // const uniqueFrequencies = new Set(frequencyItem);
      // if (uniqueFrequencies.size < frequencyItem.length) {
      //     this.toasterService.error(`frequencies cannot be the same for documentType : ${frequencyItem[5]}`);
      //     result = true;
      // }
    });
    return result;
  }

  fillFormArray(list=[]) {
    this.getFormArray().clear();
    console.log(this.getFormArray().value)
    list.forEach(item => {
      this.getFormArray().push(this.createFrequencyFormGroup(item))
    })
    console.log(this.getFormArray().controls)
  }

  toggleEdit() {
    this.isEditing = true
  }

  initializaForm() {
    this.frequencyForm = this.fb.group(
      {
        docFrequencyList : this.fb.array([])
      }
    )
  }

  getFormArray() {
    return this.frequencyForm?.get('docFrequencyList') as FormArray;
  }

  createFrequencyFormGroup(item) {
    return this.fb.group({
      id: item?.id,
      documentType: item?.documentType,
      userId: item?.userId,
      userType: item?.userType,
      frequency1: item?.frequency1,
      frequency2: item?.frequency2,
      frequency3: item?.frequency3,
      frequency4: item?.frequency4,
      frequency5: item?.frequency5,
      activeIndicator: item?.activeIndicator
    })
  }

}
